import React from 'react';

import Position from './Components/Position'
import CancelEdit from './Components/CancelEdit';

export default function DisplayProperties({ question, position }) {
  return <>
    <p style={{ whiteSpace: 'pre-line' }}><strong>Display {question.linkId}:</strong> {question.text}</p>

    <Position question={question} position={position} />

    <CancelEdit />
  </>

}